import {Pipe, PipeTransform} from '@angular/core';
import {TupleIdName} from '../models/tuple.model';
import {I18nService} from '../../shared/i18n';
import {DocumentTypeCodebook} from '../codebook/document-type-codebook';
import {CodebookModel} from '../models/codebook.model';
import {ThematicGroupTypeCodebook} from '../codebook/thematic-group-type-codebook';

@Pipe({
    name: 'thematicGroup'
})
export class ThematicGroupPipe implements PipeTransform {
    private allTypes:CodebookModel[] = ThematicGroupTypeCodebook.allTypes;
    constructor() {
    }


    transform(value: any, args?: any): any {

        let  type = this.allTypes.filter(type => type.id === value)[0];
        if(type == null) {
            type = {id:-1,name:'n/a'}
        }
        return type.name;
    }

}


// WEBPACK FOOTER //
// ./src/app/+app-custom/pipes/thematicGroup.pipe.ts